
// Bundle Page JS
$(document).on('click', '.variant_item', function() {
  let parentnod = $(this).closest('.build-bundle-product_card');
  parentnod.find('.variant_item').removeClass('active');
  $(this).addClass('active');
  let img_src = $(this).attr('data-img-url')
  $(this).parents('.build-bundle-product_card').find('.build-bundle-product_card_media img').attr('srcset', img_src);
  syncBundleButtons()
});

$(document).on('click', '.build-bundle_tab_item:not(.show_all)', function(){
  var index = $('.build-bundle_tab_item:not(.show_all)').index(this);
  $('.build-bundle_tab_item').removeClass('active');
  $(this).addClass('active');
  $('.build-bundle-products_item').removeClass('active');
  $('.build-bundle-products_item').eq(index).addClass('active');
});
$(document).on('click', '.build-bundle_tab_item.show_all', function(){
  $('.build-bundle_tab_item').removeClass('active');
  $(this).addClass('active');
  $('.build-bundle-products_item').addClass('active');
});

function formatPrice(amount) {
  return parseFloat(amount.toFixed(2));
}
function syncBundleButtons() {
  $('.build-bundle-product_card').each(function(){
    let card = $(this);
    let btn = card.find('.ct-build_bundle_add');
    let variantId = card.find('.variant_item.active').data('variant-id');

    let exists = bundleItems.some(item => item.id == variantId);

    if(exists){
      btn.addClass('added');
      btn.find('span').text('Remove');
    } else {
      btn.removeClass('added');
      btn.find('span').text('Add');
    }
  });
}

let bundleItems = [];
const maxItems = 6;
// let discount_15 = 'CTKIT15'
// let discount_18 = 'CTKIT18'
// let discount_25 = 'CTKIT25'
function updateBundleOffers() {
  $('.ct_bundle_offer_p').removeClass('active');

  if (bundleItems.length >= 3) {
    $('.ct_bundle_offer_3').addClass('active');
  }

  if (bundleItems.length >= 4) {
    $('.ct_bundle_offer_4').addClass('active');
  }

  if (bundleItems.length >= 6) {
    $('.ct_bundle_offer_6').addClass('active');
  }
}
function money(val) {
  return Number(val).toLocaleString('en-IN', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  });
}
$(document).on('click', '.ct-build_bundle_add', function() {
  let card = $(this).closest('.build-bundle-product_card');
  let variantId = card.find('.variant_item.active').data('variant-id');
  let product = {
    id: variantId,
    title: $(this).data('title'),
    price: $(this).data('price'),
    image: card.find('.variant_item.active').attr('data-img-url')
  };
  let index = bundleItems.findIndex(p => p.id == product.id);
  let btn = $(this);

  if(index > -1){
    bundleItems.splice(index, 1);
    btn.removeClass('added');
    btn.find('span').text('Add');

  } else {
    if(bundleItems.length >= maxItems){
      alert('Max 6 items allowed');
      return;
    }

    bundleItems.push(product);

    btn.addClass('added');
    btn.find('span').text('Remove');
  }
  if (bundleItems.length > 2) {
    $('.ct_bundle_atc_btn').removeAttr('disabled');
  } else {
    $('.ct_bundle_atc_btn').attr('disabled', 'disabled');
  }
  if(window.innerWidth < 750) {
    updateBundleUImob();
  }else {
    updateBundleUI();
  }
  syncBundleButtons();
  let progress = bundleItems.length / maxItems * 100;
  $('.ct_bundle_progress_bar').css("width", `${progress}%`);
  updateBundleOffers();
  let totalPrice = bundleItems.reduce((sum, item) => {
    let price = item.price;
    if (!price) return sum;
    price = price.toString().replace(/[^0-9.]/g, '');
    return sum + Number(price);
  }, 0);
  
  let discount = 0;
  if (bundleItems.length == 6) {
    discount = 25;
    // $('.ct_bundle_atc_btn').attr('data-discount',discount_25);
  } else if (bundleItems.length >= 4) {
    discount = 18;
    // $('.ct_bundle_atc_btn').attr('data-discount',discount_18);
  } else if (bundleItems.length == 3) {
    discount = 15;
    // $('.ct_bundle_atc_btn').attr('data-discount',discount_15);
  }

  if (bundleItems.length == 6) {
    $('.shipping-ticker__progress-txt').text("25% Savings Unlocked");
  }
  else if (bundleItems.length < 6 && bundleItems.length >= 4) {
    let get = 6 - bundleItems.length;
    $('.shipping-ticker__progress-txt').text(`18% Savings Unlocked • Add ${get} More for 25% Off`);
  } else if (bundleItems.length >= 3 && bundleItems.length <= 4) {
    $('.shipping-ticker__progress-txt').text(`15% Savings Unlocked • Add 1 More for 18% Off`);
  } else if (bundleItems.length < 3 && bundleItems.length >= 1) {
    let get = 3 - bundleItems.length;
    $('.shipping-ticker__progress-txt').text(`Add ${get} More to Unlock 15% Off`);
  } else if (bundleItems.length == 0) {
    $('.shipping-ticker__progress-txt').text(`Add 3 to Unlock 15% Off`);
  }

  let save_discount_price = (totalPrice * discount) / 100;
  let discount_price = totalPrice - save_discount_price;
  $('.ct_bundle_total_price').text(`₹${money(discount_price)}`);
  if (bundleItems.length > 2) {
    $('.ct_bundle_total_compare_price').text(`₹${money(totalPrice)}`);
    $('.ct_bundle_total_compare_price').css('display', 'block');
  }
  if (bundleItems.length < 3) {
    $('.ct_bundle_total_compare_price').css('display', 'none');
  }
  $('.savetotal_price').text(`₹${save_discount_price}`); 
  $('.selected_bndle_length').text(bundleItems.length);
});

$(document).on('click', '.remove-item', function(e){
  e.stopPropagation();
  let id = $(this).attr('data-id');
  bundleItems = bundleItems.filter(p => p.id != Number(id));
  
  if (bundleItems.length > 2) {
    $('.ct_bundle_atc_btn').removeAttr('disabled');
  } else {
    $('.ct_bundle_atc_btn').attr('disabled', 'disabled');
  }
  if(window.innerWidth < 750) {
    updateBundleUImob();
  }else {
    updateBundleUI();
  }
  syncBundleButtons();
  let progress = bundleItems.length / maxItems * 100;
  $('.ct_bundle_progress_bar').css("width", `${progress}%`);
  updateBundleOffers();
  let totalPrice = bundleItems.reduce((sum, item) => {
    let price = item.price;
    if (!price) return sum;
    price = price.toString().replace(/[^0-9.]/g, '');
    return sum + Number(price);
  }, 0);
  
  let discount = 0;
  if (bundleItems.length == 6) {
    discount = 25;
    // $('.ct_bundle_atc_btn').attr('data-discount',discount_25);
  } else if (bundleItems.length >= 4) {
    discount = 18;
    // $('.ct_bundle_atc_btn').attr('data-discount',discount_18);
  } else if (bundleItems.length == 3) {
    discount = 15;
    // $('.ct_bundle_atc_btn').attr('data-discount',discount_15);
  } 
  // else {
  //   $('.ct_bundle_atc_btn').removeAttr('data-discount');
  // }

  if (bundleItems.length == 6) {
    $('.shipping-ticker__progress-txt').text("You get 25% OFF!");
  }
  else if (bundleItems.length < 6 && bundleItems.length >= 4) {
    let get = 6 - bundleItems.length;
    $('.shipping-ticker__progress-txt').text(`You get 18% OFF!, Add ${get} more to SAVE 25%`);
  } else if (bundleItems.length >= 3 && bundleItems.length <= 4) {
    $('.shipping-ticker__progress-txt').text(`You get 15% OFF!, Add 1 more to SAVE 18%`);
  } else if (bundleItems.length < 3 && bundleItems.length >= 1) {
    let get = 3 - bundleItems.length;
    $('.shipping-ticker__progress-txt').text(`Add ${get} more to SAVE 15%`);
  } else if (bundleItems.length == 0) {
    $('.shipping-ticker__progress-txt').text(`Add 3 to Unlock 15% Off`);
  }
  let save_discount_price = (totalPrice * discount) / 100;
  let discount_price = totalPrice - save_discount_price;
  $('.ct_bundle_total_price').text(`₹${money(discount_price)}`);
  // if (bundleItems.length > 2) {
    $('.ct_bundle_total_compare_price').text(`₹${money(totalPrice)}`);
  // }
  if (bundleItems.length < 3) {
    $('.ct_bundle_total_compare_price').css('display', 'none');
  }
  $('.savetotal_price').text(`₹${save_discount_price}`);
  $('.selected_bndle_length').text(bundleItems.length);
});

function updateBundleUI() {
  let items = $('.selected_build-bundle-products_Wrp .selected_build-bundle-items .bundle-item');
  items.each(function(index){
    let slot = $(this);
    let item = bundleItems[index];
    if(item){
      slot.attr('data-id', item.id);
      slot.attr('data-price', item.price);
      slot.removeClass('empty').addClass('filled');
      slot.find('img').attr('src', item.image);
      slot.find('.bundle-item-title').text(item.title);
      slot.find('.remove-item').attr('data-id', item.id).show();
      slot.find('.remove-item').attr('data-price', item.price);
      slot.find('.bundle-plus').hide();
    } else {
      slot.removeAttr('data-id');
      slot.removeAttr('data-price');
      slot.removeClass('filled').addClass('empty');
      slot.find('img').attr('src', '');
      slot.find('.bundle-item-title').text('');
      slot.find('.remove-item').hide().removeAttr('data-id');
      slot.find('.remove-item').hide().removeAttr('data-price');
      slot.find('.bundle-plus').show();
    }
  });
}

function updateBundleUImob() {

  let items = $('.selected_main_body .selected_build-bundle-items .bundle-item');
  let totalItems = bundleItems.length;
  let discount = 0;
  if (totalItems >= 6) {
    discount = 25;
  } else if (totalItems >= 4) {
    discount = 18;
  } else if (totalItems >= 3) {
    discount = 15;
  }
  items.each(function(index) {
    let slot = $(this);
    let item = bundleItems[index];
    if (item) {
      slot.attr('data-id', item.id);
      slot.attr('data-price', item.price);
      slot.removeClass('empty').addClass('filled');
      slot.find('img').attr('src', item.image);
      slot.find('.bundle-item-title').text(item.title);
      let originalPrice = parseFloat(
        item.price.toString().replace(/,/g, '')
      );
      let discountedPrice = originalPrice;
      if (discount > 0) {
        discountedPrice =
          originalPrice - (originalPrice * discount / 100);
      }
      slot.find('.bundle-item-price').show();
      if (totalItems < 3) {
        slot.find('.original-price')
          .css({
            'text-decoration': 'none',
            'color': '#000'
          })
          .text('₹' + originalPrice.toLocaleString('en-IN'));
        slot.find('.discount-price').text('');
      } else {
        slot.find('.original-price')
          .css({
            'text-decoration': 'line-through',
            'color': '#888'
          })
          .text('₹' + originalPrice.toLocaleString('en-IN'));
        slot.find('.discount-price')
          .text(
            '₹' +
            Math.round(discountedPrice).toLocaleString('en-IN')
          );
      }
      slot.find('.remove-item')
        .attr('data-id', item.id)
        .attr('data-price', item.price)
        .show();
      slot.find('.bundle-plus').hide();
    } else {
      slot.removeAttr('data-id');
      slot.removeAttr('data-price');
      slot.removeClass('filled').addClass('empty');
      slot.find('img').attr('src', '');
      slot.find('.bundle-item-title').text('');
      slot.find('.bundle-item-price').hide();
      slot.find('.original-price').text('');
      slot.find('.discount-price').text('');
      slot.find('.remove-item')
        .hide()
        .removeAttr('data-id')
        .removeAttr('data-price');
      slot.find('.bundle-plus').show();
    }
  });
}


$(document).on('click', '.ct_bundle_atc_btn', function(e){
  e.preventDefault();
  let btn = $(this);
  let itemsArray = [];
  const BUILDER_KEY = 'Page-Type'; 
  const BUILDER_VALUE = 'custom_builder';
  $(".bundle-item.filled").each(function() {
    let id = $(this).attr('data-id');
    if(id){
      itemsArray.push({
        id: id,
        quantity: 1,
        properties: {
          '_page': 'byok'
        }
      });
    }
  });
  if(itemsArray.length == 0){
    alert('Please add products');
    return;
  }
  btn.addClass('loading');
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      items: itemsArray
      // attributes: {
      //   [BUILDER_KEY]: BUILDER_VALUE
      // }
    })
  })
  .then(res => res.json())
  .then(() => {
    setTimeout(() => {
      document.querySelector('.header__icon--cart, a[href="/cart"]')?.click();
      btn.removeClass('loading');
    }, 100);
    return fetch('/cart.js');
  })
  .then(res => res.json())
  .then(cart => {
    document.dispatchEvent(new CustomEvent('cart:refresh', {
      detail: { cart: cart }
    }));
    setTimeout(() => {
      // $($('.remove-item').get().reverse()).each(function () {
      //   $(this).trigger('click');
      // });
      bundleItems = [];

      if (window.innerWidth < 750) {
        updateBundleUImob();
      } else {
        updateBundleUI();
      }

      syncBundleButtons();
      updateBundleOffers();

      $('.ct_bundle_progress_bar').css("width", "0%");
      $('.selected_bndle_length').text("0");
      $('.ct_bundle_total_price').text("₹0");
      $('.ct_bundle_total_compare_price').hide();
      $('.savetotal_price').text("₹0");
      $('.shipping-ticker__progress-txt').text("Add 3 to Unlock 15% Off");
      $('.ct_bundle_atc_btn').attr('disabled', 'disabled');
    }, 1000);
  })
  .catch(err => {
    console.log(err);
    btn.removeClass('loading');
  });
});



$('.selected_bndle_heading').click(function(){
  $(this).toggleClass('active');
  $('.selected_main_body').toggleClass('active');
});

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(() => {
    var elem = document.querySelector('.ct_complementary_bundle_wrp');
    if (elem && typeof Flickity !== 'undefined') {
      new Flickity(elem, {
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        prevNextButtons: true,
      });
    }
  }, 1000);
});